import SpinnerLoad
  from '../../Components/Molecules/Loader/SpinnerLoad/SpinnerLoad';

export function loadingData(data,props) {
  if (data === true || data === [] || data === null || data === undefined) {
    return <SpinnerLoad  t={props.t}/>;
  }
}
